export default "__VITE_ASSET__DQuRXXUt__"